/* eslint-disable camelcase */
import { createDerivedSurveys as createACDerivedSurveys } from './util/AC';

import { createDerivedSurveys as createDOCDerivedSurveys } from './util/DOC';

import { createDerivedSurveys as createSpatialDerivedSurveys } from './util/SPATIAL';

import { createDerivedSurveys as createIliExtMtlLossDerivedSurveys } from './util/ILI_EXT_MTL_LOSS';

import { createDerivedSurveys as createIliIntMtlLossDerivedSurveys } from './util/ILI_INT_MTL_LOSS';

const combineDataSources = dataSources =>
	dataSources.reduce(
		(acc, obj) => ({
			surveys: [...acc.surveys, ...obj.surveys],
			readingsMeta: { ...acc.readingsMeta, ...obj.readingsMeta },
			readings: { ...acc.readings, ...obj.readings },
			readingsIndexMap: { ...acc.readingsIndexMap, ...obj.readingsIndexMap },
			readingsMap: {
				...acc.readingsMap,
				...obj.readingsMap
			},
			readingsWithChartGaps: {
				...acc.readingsWithChartGaps,
				...obj.readingsWithChartGaps
			},
			readingsWithChartGapsIndexMap: {
				...acc.readingsWithChartGapsIndexMap,
				...obj.readingsWithChartGapsIndexMap
			},
			readingsWithGeoGapsIndexMap: {
				...acc.readingsWithGeoGapsIndexMap,
				...obj.readingsWithGeoGapsIndexMap
			},
			readingsWithGeoGaps: {
				...acc.readingsWithGeoGaps,
				...obj.readingsWithGeoGaps
			},
			series: { ...acc.series, ...obj.series },
			seriesIndexMap: { ...acc.seriesIndexMap, ...obj.seriesIndexMap },
			readingsStationIdIntegers: {
				...acc.readingsStationIdIntegers,
				...obj.readingsStationIdIntegers
			}
		}),
		{
			surveys: [],
			readingsMeta: {},
			readings: {},
			readingsIndexMap: {},
			readingsMap: {},
			readingsWithChartGaps: {},
			readingsWithChartGapsIndexMap: {},
			readingsWithGeoGapsIndexMap: {},
			readingsWithGeoGaps: {},
			series: {},
			seriesIndexMap: {},
			readingsStationIdIntegers: {}
		}
	);

export const createDerivedSurveys = (
  parentSurvey,
	processedReadings,
	processedReadingsWithChartGaps,
	processedReadingsWithGeoGaps,
	type,
	surveyReadings,
	jobId,
	meta,
	isParentSurveyChecked,
	end_date,
	parent_survey_subtype,
	job_number
) => {
  let acDataSources;
  let docDataSources;
  let spatialDataSources;
  let iliExternalMtlLoass;
  let iliInternalMtlLoass;

  if (parent_survey_subtype !== 'ILI') {
    acDataSources = createACDerivedSurveys(
      parentSurvey,
      processedReadings,
      processedReadingsWithChartGaps,
      processedReadingsWithGeoGaps,
      type,
      surveyReadings,
      jobId,
      meta,
      isParentSurveyChecked,
      end_date,
      parent_survey_subtype,
      job_number
    );
    docDataSources = createDOCDerivedSurveys(
      parentSurvey,
      processedReadings,
      processedReadingsWithChartGaps,
      processedReadingsWithGeoGaps,
      type,
      surveyReadings,
      jobId,
      meta,
      end_date,
      parent_survey_subtype,
      job_number
    );
    spatialDataSources = createSpatialDerivedSurveys(
      parentSurvey,
      processedReadings,
      processedReadingsWithChartGaps,
      processedReadingsWithGeoGaps,
      type,
      surveyReadings,
      jobId,
      meta,
      end_date,
      parent_survey_subtype,
      job_number
    );
  } else { 
    iliExternalMtlLoass = createIliExtMtlLossDerivedSurveys(
      parentSurvey,
      processedReadings,
      processedReadingsWithChartGaps,
      processedReadingsWithGeoGaps,
      type,
      surveyReadings,
      jobId,
      meta,
      end_date,
      parent_survey_subtype,
      job_number
    )
    iliInternalMtlLoass = createIliIntMtlLossDerivedSurveys(
      parentSurvey,
      processedReadings,
      processedReadingsWithChartGaps,
      processedReadingsWithGeoGaps,
      type,
      surveyReadings,
      jobId,
      meta,
      end_date,
      parent_survey_subtype,
      job_number
    )
  }

	return combineDataSources([
		docDataSources,
		acDataSources,
    spatialDataSources,
    iliExternalMtlLoass,
    iliInternalMtlLoass
	].filter(v => v));
};

export default { createDerivedSurveys };
